<template>
  <div class="min-w-max-content">
    <el-date-picker
      class="dashboard-date-picker-condensed cursor-pointer"
      :value="dateRange"
      format="MMM d"
      type="daterange"
      align="right"
      unlink-panels
      start-placeholder="Start date"
      end-placeholder="End date"
      :default-time="['00:00:00', '23:59:59']"
      :picker-options="pickerOptions"
      @input="handlePick"
      :clearable="false"
      :disabled="disabled"
    >
      <span class="text-gray-400 font-semibold" slot="range-separator"> - </span>
    </el-date-picker>
  </div>
</template>

<script>
/* eslint-disable indent */
import { timeDay, timeWeek, timeMonth, timeYear } from 'd3-time';
import { getDateEndpoints } from '@/helpers/date-utils';
import { mapGetters } from 'vuex';

export default {
  name: 'DatePicker',
  props: {
    dateRange: Array,
    disabled: Boolean,
  },
  data() {
    return {};
  },
  methods: {
    handlePick(value) {
      this.$emit('change', value);
    },
  },
  computed: {
    ...mapGetters(['orgCreatedDate']),
    pickerOptions() {
      return {
        shortcuts: [
          {
            text: 'Last 7 days',
            onClick(picker) {
              const endDate = new Date();
              const startDate = timeDay.offset(endDate, -6);
              picker.$emit('pick', getDateEndpoints([startDate, endDate]));
            },
          },
          {
            text: 'Last 30 days',
            onClick(picker) {
              const endDate = new Date();
              const startDate = timeDay.offset(endDate, -29);
              picker.$emit('pick', getDateEndpoints([startDate, endDate]));
            },
          },
          {
            text: 'Last 90 days',
            onClick(picker) {
              const endDate = new Date();
              const startDate = timeDay.offset(endDate, -89);
              picker.$emit('pick', getDateEndpoints([startDate, endDate]));
            },
          },
          {
            text: 'This Week',
            onClick(picker) {
              const endDate = new Date();
              const startDate = timeWeek.floor(endDate);
              picker.$emit('pick', getDateEndpoints([startDate, endDate]));
            },
          },
          {
            text: 'This Month',
            onClick(picker) {
              const endDate = new Date();
              const startDate = timeMonth.floor(endDate);
              picker.$emit('pick', getDateEndpoints([startDate, endDate]));
            },
          },
          {
            text: 'This Year',
            onClick(picker) {
              const endDate = new Date();
              const startDate = timeYear.floor(endDate);
              picker.$emit('pick', getDateEndpoints([startDate, endDate]));
            },
          },
          ...(this.orgCreatedDate
            ? [
                {
                  text: 'All Time',
                  onClick: (picker) => {
                    const endDate = new Date();
                    const startDate = new Date(this.orgCreatedDate);
                    picker.$emit('pick', getDateEndpoints([startDate, endDate]));
                  },
                },
              ]
            : []),
        ],
      };
    },
  },
};
</script>

<style lang="scss">
.dashboard-date-picker-condensed {
  max-width: 130px;
  @apply border-white;
  @apply border-brand-gray-blue;
  @apply text-brand-blue;
  border-width: 2px;
  @apply border-solid;
  @apply rounded-md;
  &.el-input__inner {
    line-height: 44px;
    height: 44px;
  }
  .el-range-input {
    @apply text-xs;
    @apply font-semibold;
    @apply text-brand-blue;
    width: 48%;
  }
  .el-range-separator {
    @apply font-semibold;
  }
  .el-range__icon {
    @apply font-bold;
    @apply text-brand-blue;
    @apply text-lg;
    @apply mt-1;
  }
  .el-range__close-icon {
    @apply hidden;
  }
}
</style>
